import { render, staticRenderFns } from "./activityWeapp.vue?vue&type=template&id=357391a0&scoped=true"
import script from "./activityWeapp.vue?vue&type=script&lang=js"
export * from "./activityWeapp.vue?vue&type=script&lang=js"
import style0 from "./activityWeapp.vue?vue&type=style&index=0&id=357391a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357391a0",
  null
  
)

component.options.__file = "activityWeapp.vue"
export default component.exports